/*jshint esversion: 6 */
// Shared URL helpers for analytics labels ------------------- *

// Query params that Google (and other ad/analytics tools) append to a link
// at click time. Their values change on every click, so leaving them on the
// captured URL fragments the data in GA/DataStudio and prevents links such as
// "My Courses" from aggregating into the top-clicked report. These carry no
// reporting value for menu/tile click aggregation, so we strip them.
// NOTE: intentional params (utm_*, page-specific query strings like ?tab=x)
// are deliberately NOT stripped -- they represent genuinely different
// destinations / campaigns that should be counted separately.
var TRACKING_PARAMS = [
    '_gl',                                   // GA cross-domain linker
    '_ga', '_gac',                           // GA cookie linker
    '_gcl_au', '_gcl_aw', '_gcl_dc',         // Google Ads conversion linker
    'gclid', 'gclsrc', 'dclid', 'gbraid', 'wbraid', // Google Ads click ids
    'fbclid', 'msclkid', 'yclid', 'twclid',  // other ad-platform click ids
    'mc_cid', 'mc_eid', 'igshid', 'li_fat_id' // Mailchimp / IG / LinkedIn
];

export function cleanTrackingUrl(url) {
    if (!url) return url;
    try {
        var u = new URL(url, window.location.href);
        TRACKING_PARAMS.forEach(function (p) { u.searchParams.delete(p); });
        return u.toString();
    } catch (e) {
        // Malformed/relative URL the URL constructor can't parse -- leave as-is.
        return url;
    }
}

export default cleanTrackingUrl;
